(function(){
  'use strict';
  if (window.PGModernConfiguratorV146) return;
  window.PGModernConfiguratorV146=true;
  /* Some legacy product blocks force Poppins with higher-priority CSS.
     Apply the one approved heading typeface directly, leaving all inputs and prices alone. */
  function applyOptionHeadingType(form){
    var selectors=[
      '.pg-up-v51__label','.swatch_options .option_title','.swatch .option_title',
      '.pg-extras__title','.pg-choice-summary__title',
      '.background-select-section h2','.background-select-section h3',
      '.background-select-section h4','.background-select-section h5',
      '.background-select-section .option_title','.background-select-section .background-title',
      '.background-select-section .background-heading','.background-select-section .background-select-title',
      '.background-select-section .title','.background-select-section .heading',
      '.background-select-section .title-text'
    ].join(',');
    var elements=new Set(Array.prototype.slice.call(form.querySelectorAll(selectors)));
    var allowed=/^(upload your (?:pet|reference) photo(?:\(s\)|s)?|choose your (?:size|framing option|background|photo(?:s)?)|choose a background|any extras\?|your choices)$/i;
    Array.prototype.forEach.call(form.querySelectorAll('h2,h3,h4,h5,p,.option_title,.title,.heading,strong'),function(el){
      if(el.children.length>3 || el.querySelector('button,input,a'))return;
      var wording=String(el.textContent||'').trim().replace(/\s+/g,' ');
      if(allowed.test(wording))elements.add(el);
    });
    elements.forEach(function(el){
      if(el.closest('.pg-cfg-progress'))return;
      var target=[el].concat(Array.prototype.slice.call(el.querySelectorAll('span,strong,b,em,i')));
      target.forEach(function(x){
        x.style.setProperty('font-family','"Playfair Display", Georgia, serif','important');
        x.style.setProperty('font-style','italic','important');
        x.style.setProperty('font-weight','500','important');
        x.style.setProperty('letter-spacing','-.018em','important');
      });
      el.classList.add('pg-v146-playfair-option-heading');
    });
  }
  function boot(){
    var host=document.querySelector('[data-product-form].pg-cfg-on');
    if(!host)return;
    var progress=host.querySelector('.pg-cfg-progress');
    var footer=host.querySelector('.pg-cfg-footer');
    if(!progress||!footer)return;
    var form=progress.closest('form');
    if(!form)return;
    if(form.classList.contains('pg-modern-configurator-v146')){applyOptionHeadingType(form);return;}
    form.classList.add('pg-modern-configurator-v146');
    applyOptionHeadingType(form);
    var dots=Array.prototype.slice.call(progress.querySelectorAll('.pg-cfg-step-dot'));
    if(!dots.length)return;
    var count=dots.length;
    progress.style.setProperty('--pg-modern-step-count',String(count));
    progress.classList.toggle('pg-modern-many-steps',count>4);
    var meter=document.createElement('div');
    meter.className='pg-modern-step-meter';
    meter.innerHTML='<div class="pg-modern-step-track" role="progressbar" aria-label="Portrait configuration progress" aria-valuemin="0" aria-valuemax="'+count+'">'+
      '<span class="pg-modern-step-fill"></span>'+
      '<span class="pg-modern-step-paw" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><circle cx="6" cy="7" r="2.2"/><circle cx="12" cy="4.5" r="2.2"/><circle cx="18" cy="7" r="2.2"/><circle cx="20" cy="12" r="1.8"/><path d="M12 10c-2.3 0-3.7 2.3-5.2 4.2C4 17.8 7 21 10 19.8c1.3-.6 2.7-.6 4 0 3 1.2 6-2 3.2-5.6C15.7 12.3 14.3 10 12 10z"/></svg></span>'+
      '</div><div class="pg-modern-step-details" aria-live="polite"><span data-pg-modern-position></span><span data-pg-modern-remaining></span></div>';
    progress.insertAdjacentElement('afterend',meter);
    var track=meter.querySelector('.pg-modern-step-track');
    var fill=meter.querySelector('.pg-modern-step-fill');
    var paw=meter.querySelector('.pg-modern-step-paw');
    var position=meter.querySelector('[data-pg-modern-position]');
    var remaining=meter.querySelector('[data-pg-modern-remaining]');
    var next=footer.querySelector('[data-cfg-next]');
    var back=footer.querySelector('[data-cfg-back]');
    if(back&&!back.dataset.pgModernLabel){
      back.dataset.pgModernLabel='1';
      back.textContent='Back';
    }
    function paintPrimaryV146(button,final){
      if(!button || !button.style)return;
      /* Mobile sticky Add to Cart is driven by a different legacy controller. 
         Apply the stage colour at the element to avoid race conditions in older theme CSS. */
      var green=final;
      button.style.setProperty('background-color',green?'#37885b':'#eda8bc','important');
      button.style.setProperty('border-color',green?'#37885b':'#eda8bc','important');
      button.style.setProperty('color',green?'#ffffff':'#283343','important');
      button.style.setProperty('background-image','none','important');
      button.style.setProperty('box-shadow',green?'0 3px 12px rgba(45,116,76,.14)':'0 3px 12px rgba(169,95,124,.10)','important');
    }
    function applySubtotalPlayfairV146(){
      var items=document.querySelectorAll(
        '.pg-modern-configurator-v146 .pg-cfg-footer .pg-cfg-subtotal,'+
        '.pg-modern-configurator-v146 .pg-cfg-footer .pg-cfg-subtotal__label,'+
        '.pg-modern-configurator-v146 .pg-cfg-footer .pg-cfg-subtotal__amount,'+
        '.pg-sticky-atc .pg-sticky-atc__subtotal,'+
        '.pg-sticky-atc .pg-sticky-atc__label,'+
        '.pg-sticky-atc .pg-sticky-atc__subtotal strong,'+
        '.pg-sticky-atc [data-pg-sticky-price]');
      Array.prototype.forEach.call(items,function(node){
        [node].concat(Array.prototype.slice.call(node.querySelectorAll('span,strong,b,em,i,.money'))).forEach(function(el){
          el.style.setProperty('font-family','"Playfair Display", Georgia, serif','important');
          el.style.setProperty('font-style','italic','important');
          el.style.setProperty('font-weight','600','important');
          el.style.setProperty('letter-spacing','-.018em','important');
        });
      });
    }
    function sync(){
      applyOptionHeadingType(form);
      applySubtotalPlayfairV146();
      var active=dots.findIndex(function(d){return d.classList.contains('is-active')});
      if(active<0)active=0;
      var step=active+1,pct=Math.min(100,Math.max(0,Math.round(100*step/count)));
      fill.style.width=pct+'%';
      paw.style.left='clamp(13px, '+pct+'%, calc(100% - 13px))';
      position.textContent='Step '+step+' of '+count;
      var left=count-step;
      var final=active===count-1;
      form.classList.toggle('pg-modern-final-step-v146',final);
      document.body.classList.toggle('pg-modern-final-step-v146',final);
      paintPrimaryV146(next,final);
      paintPrimaryV146(document.querySelector('[data-pg-sticky-atc] [data-pg-sticky-btn]'),final);
      remaining.textContent=left===0?'Ready to add to cart':left+' step'+(left===1?'':'s')+' to go';
      track.setAttribute('aria-valuenow',String(step));
      track.setAttribute('aria-valuetext','Step '+step+' of '+count);
      dots.forEach(function(dot,i){
        if(!dot.dataset.pgModernAccessible){
          dot.dataset.pgModernAccessible='1';
          dot.setAttribute('role','button');
          dot.addEventListener('keydown',function(e){
            if((e.key==='Enter'||e.key===' ')&&i<=dots.findIndex(function(n){return n.classList.contains('is-active')})){
              e.preventDefault();dot.click();
            }
          });
        }
        dot.tabIndex=i<=active?0:-1;
        dot.setAttribute('aria-disabled',i>active?'true':'false');
        if(i===active)dot.setAttribute('aria-current','step');else dot.removeAttribute('aria-current');
      });
      if(next&&!next.disabled&&next.getAttribute('aria-busy')!=='true'){
        var desired=(final?'Add to cart':'Next')+' <span class="pg-modern-next-arrow" aria-hidden="true">→</span>';
        if(next.innerHTML!==desired)next.innerHTML=desired;
        next.setAttribute('aria-label',final?'Add to cart':'Next step');
      }
    }
    sync();
    document.addEventListener('pg-cfg-step',function(){sync()});
    if(window.MutationObserver){
      var observer=new MutationObserver(function(){sync()});
      observer.observe(progress,{subtree:true,attributes:true,attributeFilter:['class']});
    }
  }
  function init(){boot();window.setTimeout(boot,200);window.setTimeout(boot,800)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',boot);
})();